import { fetchBrandConfig, Brand } from 'AppBranding';

const quanticLogo = fetchBrandConfig(Brand.quantic).appMenuProgramLogo;
const valarLogo = fetchBrandConfig(Brand.valar).appMenuProgramLogo;

export function getBrandLogo(branding: string) {
    if (branding === 'valar') return valarLogo;
    return quanticLogo;
}

export function getBrandColor(branding: string) {
    return branding === 'valar' ? '#4d7aff' : '#ff4d63';
}
